import { render, staticRenderFns } from "./upload2.vue?vue&type=template&id=2d7bdca0&"
import script from "./upload2.vue?vue&type=script&lang=js&"
export * from "./upload2.vue?vue&type=script&lang=js&"
import style0 from "./upload2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports